import FormattedRecordBlockExpectedRecord from "@/src/components/custom_components/FormattedRecordBlockExpectedRecord.vue";
import FormattedRecordBlockCurrentRecord from "@/src/components/custom_components/FormattedRecordBlockCurrentRecord.vue";
import CampaignChannelCell from "@/src/components/custom_components/CampaignChannelCell.vue";
import CampaignStatusTag from "@/src/components/custom_components/CampaignStatusTag.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import { createDateFilters } from "@/src/constants/filterConstants.js";

export const campaignChannelIcons = {
  email: imageNames.CHANNEL_EMAIL,
  whatsapp: imageNames.CHANNEL_WHATSAPP,
  sms: imageNames.SMS_GREY,
};

export const campaignInEngageHeaders = [
  {
    label: "Name",
    key: "name",
    width: 4,
    sortable: true,
  },
  { label: "Status", key: "status", width: 4, sortable: true },
  {
    label: "Created On",
    key: "created_at",
    width: 4,
    html: true,
    sortable: true,
  },
];

export const campaignChannelColumnRender = {
  name: {
    component: CampaignChannelCell,
    props: (record) => ({
      row: record,
      source: "campaign_in_engage",
    }),
  },
  status: {
    component: CampaignStatusTag,
    props: (record) => ({
      value: record.status,
      source: "campaigns_in_engage",
      failureReason: record.failure_reason,
      failedAt: record.failed_at,
    }),
  },
};

export const campaignEmailFilters = [
  {
    id: "status",
    name: "Status",
    options: [
      { id: "", name: "Pending" },
      { id: "voicemail", name: "Voicemail" },
      { id: "voicemail-dropped", name: "Voicemail-Dropped" },
    ],
    searchable: true,
    multiSelect: false,
    showInitials: false,
  },
];

export const recipientHeader = [
  { label: "Name", key: "name", width: 200 },
  { label: "Email", key: "email", width: 250 },
];

export const whatsAppDraftRecipientHeaders = [
  { label: "Name", key: "name", width: 200 },
  { label: "Phone Number", key: "phone_number", width: 200 },
];

export const whatsAppSentRecipientHeaders = [
  { label: "Name", key: "name", width: 200 },
  { label: "Phone Number", key: "phone_number", width: 200 },
  { label: "Status", key: "status", width: 150, type: "status" },
  { label: "Sent Time", key: "sent_time", width: 180 },
  { label: "Delivered At", key: "delivered_at", width: 180 },
  { label: "Opened At", key: "opened_at", width: 180 },
  { label: "Replied At", key: "replied_at", width: 180 },
];

export const sentRecipientHeaders = [
  { label: "Name", key: "name", width: 200 },
  { label: "Email", key: "email", width: 250 },
  { label: "Status", key: "status", width: 150, type: "status" },
  { label: "Sent Time", key: "sent_time", width: 180 },
  { label: "Delivered At", key: "delivered_at", width: 180 },
  { label: "Opened At", key: "opened_at", width: 180 },
  { label: "Clicked At", key: "clicked_at", width: 180 },
];


export const linkActivityHeader = [
  { label: "Link", key: "link", width: 2 },
  { label: "Total Clicks", key: "total_clicks", width: 2 },
  { label: "Unique Clicks", key: "unique_clicks", width: 2 },
];

export const senderDetailsHeader = [
  { label: "Emails", key: "email", width: 5 },
  { label: "Status", key: "status", width: 5 },
  { label: "", key: "verify", width: 2 },
];

export const senderDomainHeader = [
  { label: "Sending Domain", key: "sending_domain", width: 6 },
  { label: "Status", key: "status", width: 6 },
];

export const domainDNSHeaders = [
  { label: "Type", key: "type", width: 1 },
  { label: "Host Name", key: "host_name", width: 3 },
  { label: "Expected Records", key: "expected_record", width: 3 },
  { label: "Current Records", key: "current_record", width: 3 },
  { label: "Status", key: "status", width: 2 },
];

export const domainDNSPriorityHeaders = [
  { label: "Type", key: "type", width: 1 },
  { label: "Host Name", key: "host_name", width: 2 },
  { label: "Priority", key: "priority", width: 1 },
  { label: "Expected Records", key: "expected_record", width: 3 },
  { label: "Current Records", key: "current_record", width: 3 },
  { label: "Status", key: "status", width: 2 },
];
export const domainCustomColumnRender = {
  host_name: {
    component: FormattedRecordBlockExpectedRecord,
    props: () => ({ field: 'host_name' })
  },
  expected_record: FormattedRecordBlockExpectedRecord,
  current_record: FormattedRecordBlockCurrentRecord,
};

// Turns the stored failure_reason into a message that's safe to show customers
export const getCampaignFailureMessage = (failureReason) => {
  if (!failureReason) return "";

  const stoppedAt = failureReason.match(/failed at cursor (\d+)/);
  if (stoppedAt) {
    const sent = Number(stoppedAt[1]).toLocaleString("en-US");
    return `Sending stopped after ${sent} recipients because the rest of the audience couldn't be loaded.`;
  }
  if (failureReason.startsWith("Reported FAILED by super-communication")) {
    return "Sending was stopped by the email service, for example because there weren't enough credits.";
  }
  return "Something went wrong while sending this campaign.";
};

export const mapCampaignStatus = (apiStatus) => {
  const statusMap = {
    'NEW': 'Draft',
    'DRAFT': 'Draft',
    'ACTIVE': 'Active',
    'PAUSED': 'Paused',
    'COMPLETE': 'Completed', 
    'ENDED': 'Ended',
    'CANCELLED': 'Cancelled',
    'FAILED': 'Failed',
    'IN_ACTIVE': 'Inactive',   
    'IN_PROGRESS': 'In Progress',
    'PENDING': 'Pending',
    'SCHEDULED': 'Scheduled',
    'SCHEDULED_PROCESSING': 'Scheduled Processing',
    'SENT': 'Sent',
    'NOT_SENT': 'Not Sent',
  };
  return statusMap[apiStatus] || 'Draft'; 
};

export const CONTENT_TYPE_MAP = {
  plaintext: 'TEXT',
  html: 'HTML',
  dragndrop: 'DESIGN'
};

export const CONTENT_TYPES = {
  PLAINTEXT: 'plaintext',
  HTML: 'html',
  DRAGNDROP: 'dragndrop'
};

export const CONTENT_TYPE_LABELS = {
  [CONTENT_TYPES.PLAINTEXT]: 'Plain Text',
  [CONTENT_TYPES.HTML]: 'Custom HTML',
  [CONTENT_TYPES.DRAGNDROP]: 'Drag and Drop',
  default: 'Preview'
};

export const ENTITY_TYPES = {
  CONTACT: 'contact',
  LEAD: 'lead'
};

export const PREVIEW_MODES = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
};

export const SEND_TYPES = {
  SCHEDULE: 'schedule',
  NOW: 'now'
};

export const SCHEDULE_TIME_TYPES = {
  SPECIFIC_TIME: 'specific_time',
  IMMEDIATE: 'immediate'
};

export const DEFAULT_CAMPAIGN_FORM_STATE = {
  sendType: 'schedule', // matches SEND_TYPES.SCHEDULE
  date: null,
  time: null,
  timezone: null,
  sendPerTimezone: false,
  accessType: null,
};

export const DEFAULT_CAMPAIGN_DATA = {
  name: '',
  subject: '',
  previewText: '',
  senderName: '',
  senderEmail: null,
  useReplyTo: true,
  recipientLists: [],
  excludeSome: false,
  excludedLists: [],
  contentType: null,
  content: '',
  replyToAddress: '',
};

export const LAUNCH_CAMPAIGN_SELECTOR_OPTIONS = [
  {
    id: "schedule",
    title: "Schedule",
    description: "Choose a future date & time to send",
    icon: "CALENDAR_GREY",
    alt: "calendar_icon",
  },
  {
    id: "now", 
    title: "Send Now",
    description: "Start sending your campaign immediately",
    icon: "SEND_GREY",
    alt: "play_icon",
  },
];


export const CHANNEL_ID = {
  EMAIL: "email",
  SMS: "sms",
  WHATSAPP: "whatsapp"
};

export const channelButtonText = {
  INSTALL_WHATSAPP: "Install WhatsApp",
  CONNECT_ACCOUNT: "Connect Account",
  CONFIGURE_DOMAIN: "Configure Domain",
  VERIFY_DOMAIN: "Verify Domain",
  CREATE_CAMPAIGN: "Create Campaign",
  CREATING_CAMPAIGN: "Creating Campaign...",
  COMING_SOON: "Coming Soon...",
};

export const CAMPAIGN_CHANNELS = [
  {
    id: CHANNEL_ID.EMAIL,
    title: "Email",
    description: "Create one time email that you can send now or schedule",
    icon: imageNames.EMAIL_GREY,
    alt: "email_icon",
    enabled: true,
    routePath: "/marketing/campaigns/create/email-campaign"
  },
  {
    id: CHANNEL_ID.SMS,
    title: "SMS",
    description: "Send an SMS or MMS campaign to your selected subscribers",
    icon: imageNames.SMS_GREY,
    alt: "sms_grey",
    enabled: false,
    buttonText: channelButtonText.COMING_SOON
  },
  {
    id: CHANNEL_ID.WHATSAPP,
    title: "WhatsApp",
    description: "Create one time WhatsApp campaign that you can send now or schedule",
    icon: imageNames.WHATSAPP_GREY,
    alt: "whatsapp_icon",
    enabled: true,
    routePath: "/marketing/campaigns/create/whatsapp-campaign"
  }
];

export const campaignRecipientStatusOptions = [
  { id: "sent", name: "Sent" },
  { id: "delivered", name: "Delivered" },
  { id: "opened", name: "Opened" },
  { id: "clicked", name: "Clicked" },
  { id: "bounced", name: "Bounced" },
  { id: "failed", name: "Failed" },
  { id: "duplicate", name: "Duplicate" },
  { id: "replied", name: "Replied" },
  { id: "skipped", name: "Skipped" },
];

export const campaignRecipientDateColumns = [
  "sent_time",
  "delivered_at",
  "opened_at",
  "clicked_at",
  "replied_at",
];

export const campaignRecipientStatusMapping = {
  COMPLETE: "Complete",
  DUPLICATE: "Duplicate",
  FAILED: "Failed",
  BOUNCED: "Bounced",
  IN_PROGRESS: "In Progress",
  SENT: "Sent",
  DRAFT: "Draft",
  SCHEDULED: "Scheduled",
  PENDING: "Pending",
  CANCELLED: "Cancelled",
  PAUSED: "Paused",
  RETRYING: "Retrying",
  SKIPPED: "Skipped",
  OPENED: "Opened",
  DELIVERED: "Delivered",
  CLICKED: "Clicked",
  REPLIED: "Replied",
};

export const EMPTY_VALUE_PLACEHOLDER = "-";
export const DEFAULT_RECIPIENT_STATUS = "Pending";
export const DATE_FORMAT_FULL = "full";

export const draftOrInProgressStatuses = [
  "draft",
  "scheduled",
  "failed",
  "in_progress",
  "retrying",
  "skipped"
];

export const EDIT_LOCK_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutes

export const emailTemplatesEmptyState = {
  search: {
    text: "No templates found",
    description: "Try a different search term",
  },
  default: {
    text: "You haven't created any email templates yet",
    description: "Create your first email template to get started with your email campaigns",
  },
};

export const createCampaignRecipientFilterOptions = (isWhatsApp = false) => {
  const statusOptions = campaignRecipientStatusOptions.filter(option => {
    if (option.id === "replied") return isWhatsApp;
    if (option.id === "clicked") return !isWhatsApp;
    return true;
  });

  const filters = [
    {
      id: "status",
      name: "Status",
      options: statusOptions,
      searchable: false,
      multiSelect: true,
      showInitials: false,
    },
    createDateFilters("sent_time", "Sent Date"),
    createDateFilters("delivered_at", "Delivered Date"),
    createDateFilters("opened_at", "Opened Date"),
  ];

  filters.push(isWhatsApp ? createDateFilters("replied_at", "Replied Date") : createDateFilters("clicked_at", "Clicked Date"));

  return filters;
};